import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { MuiSelect, MuiButton, D3Pie, D3VerticalStacked, Rte } from '../../../../../components'
import { IconTrashAdvSearch, IconDrag, IconEdit2  } from '../../../../../assets/images/icons'
import { LEGEND_COLOR_MAP, GRAPH_COLOR_PALLET1, ROLES_MM_PRIMARY } from '../../../../../constants'
import { removeAllKeepNumber } from '../../../../../util'
import { useGlobalStore } from '../../../../../store'
import { 
    OuterWrapper, Wrapper, CardTitle, 
    D3PieWrapper, D3PieLegends, D3PieLegendLabel, 
    D3DonutWrapper, D3Donut, D3DonutLabel, D3DonutValue, D3DonutPercentage,
    StatBoxWrapper, 
    D3VBarWrapper, D3VBar,
    D3HBarWrapper, D3HBar,
    FreeTextWrapper,
    HiddenWrapper
} from './style'



const ViewWidget = ({ defaultType='NA', data, row, onClick, onEditClicked }) => {
    const [pieSettings, setPieSettings] = useState(null)
    const [pieLegends, setPieLegends] = useState([])
    const [pieData, setPieData] = useState(null)
    const [statData, setStatData] = useState(null)
    const [colorPallet, setColorPallet] = useState([])
    const [barData, setBarData] = useState(null)
    const [maxBarValue, setMaxBarValue] = useState(null)
    const [freeTextValue, setFreeTextValue] = useState(null)
    // const [type, setType] = useState(data?.widgetType || data?.type || 'none')
    const type = data?.widgetType || data?.type || defaultType || 'none'
    
    const { user, isPPTModalActive } = useGlobalStore()
    const styles = { height: data.h, width: data.w, outline: `0px red solid` }
    styles.gridRowStart = data.gridRowStart
    if (data.rowspan) { styles.gridRowEnd = `span ${data.rowspan}` }
    styles.gridColumnStart = data.gridColumnStart
    if (data.colSpan) { styles.gridColumnEnd = `span ${data.colSpan}` }

    const getColor = (jsonData) => {
        const value = jsonData.colorPallet
        let colors = []
        if(value === 'SingleColor'){ colors = jsonData.data.map(d => '#614ED8') }
        else if(value === 'Multicolor'){ colors = GRAPH_COLOR_PALLET1 }
        else if(value === 'SentimentColors'){ 
            const colorArray = LEGEND_COLOR_MAP
            const colorArr = jsonData.data.map(d => {
                if(d.value1.indexOf('+') !== -1) return colorArray.Positive
                if(d.value1.indexOf('-') !== -1) return colorArray.Negative
                if(d.value1.indexOf('~') !== -1) return colorArray.Mixed
                return colorArray.Neutral
            })
            colors = colorArr // LEGEND_COLOR_MAP
        }
        setColorPallet(colors)
    }

    const hasPercentage = (val) => {
        return val.indexOf('%') !== -1
    }

    const pieFunc = (jsonData) => {
        const pieW = (data.w/2) - 30
        const pieH = (data.h - 70)
        const pieRad = 42
        const coorX = (pieW - pieRad * 2) / 2 + 5
        const coorY = (pieH - pieRad * 2) / 2
        const obj = {
            colors: getColor(jsonData),
            width: pieW,
            height: pieH,
            cx: jsonData.displayValuesOutsidePie ? coorX+8 : coorX,
            cy: jsonData.displayValuesOutsidePie ? coorY+8 : coorY,
            outerRadius: jsonData.displayValuesOutsidePie ? pieRad-10 : pieRad,
            textPosition: jsonData.displayValuesOutsidePie ? 'outside' : 'inside',
            textShow: true,
            decimal: false,
            textLocation: 2,
            textSize: '12px',
            innerRadius: jsonData.displayValuesOutsidePie ? 12 : 17,
        }
        // const data2 = jsonData.data.map(d => ({name: d.label, value: Number((d.value1).replace(/\D/g, '') || 0) })).filter(f => f.value > 0)
        const data2 = jsonData.data.map(d => ({name: d.label, value: d.value1 || 0 })).filter(f => Number((f.value+'').replace(/\D/g, '')) > 0 )
        const legends = jsonData.displayValuesOutsidePie ? [...data2].map(d => ({...d, name: `${d.name}`})) : [...data2]
        
        const checkPieTotal = data2.map((d) => removeAllKeepNumber((d.value+'').split('.')[0])).reduce((a, b) => a + b, 0)
        if (checkPieTotal < 100) { data2.push({ name: 'REMAINING_VALUE', value: 100 - checkPieTotal }) }

        setPieSettings(obj)
        setPieData(data2)
        setPieLegends(legends)
    }

    const donutCheckData = (d) => {
        const finalData = [d]
        const val = (removeAllKeepNumber(finalData[0].value+''))*1
        if (val < 100) {
            finalData.push({ name: 'REMAINING_VALUE', value: 100 - val })
        }
        finalData[0].value = val
        return finalData
    }

    const donutFunc = (jsonData) => {
        // const data2 = jsonData.data.map(d => ({name: d.label, value: Number((d.value1).replace(/\D/g, '') || 0) })).filter(f => f.value > 0)
        const data2 = jsonData.data.map(d => ({name: d.label, value:d.value1 })).filter(f => (String(f.value) + String(f.name)).length > 0)

        const pieHW = 90
        const pieRad = 44
        const coorX = (pieHW - pieRad * 2) / 2
        const coorY = (pieHW - pieRad * 2) / 2
        const obj = {
            colors: getColor(jsonData),
            width: pieHW,
            height: pieHW,
            cx: coorX,
            cy: coorY,
            outerRadius: pieRad,
            textShow: false,
            innerRadius: 38,
            textCenterTitle: ''
        }

        setPieSettings(obj)
        setPieData(data2)
    }

    const statFunc = (jsonData) => {
        getColor(jsonData)
        setStatData(jsonData)
    }

    const verticalBarFunc = (jsonData) => {
        getColor(jsonData)
        const data2 = jsonData.data.map((d,i) => ({label: d.label, value: Number((d.value1).replace(/\D/g, '') || 0) })).filter(f => f.value > 0)
        // const data2 = jsonData.data.map((d,i) => ({label: d.label, value: d.value1 })).filter(f => (String(f.value) + String(f.label)).length > 0)
        const maxValue = Math.max(...data2.map(item => (Number((item.value+'').replace(/\D/g, '')))))
        setMaxBarValue(maxValue || 100)
        setBarData(data2)
    }

    const horizontalBarFunc = (jsonData) => {
        getColor(jsonData)
        // const data2 = jsonData.data.map((d,i) => ({label: d.label, value: Number((d.value1).replace(/\D/g, '') || 0) })).filter(f => f.value > 0)
        const data2 = jsonData.data.map((d,i) => ({label: d.label, value: d.value1 })).filter(f => (String(f.value) + String(f.label)).length > 0)
        const maxValue = Math.max(...data2.map(item => (Number((item.value+'').replace(/\D/g, '')))))
        setMaxBarValue(maxValue || 100)
        setBarData(data2)
    }

    const freeTextFunc = (jsonData) => {
        setFreeTextValue(jsonData?.freeText || '')
    }

    const removeSpecialChar = (val) => {
        return (val+'').replace(/[^0-9%]/g, '');
    }

    const checkOverFlow = () => {
        const element = document.querySelector('#previewWrapper > div')
        if(element){
            const childElement = element.querySelector('.wContent')
            if(childElement){
                const isOverFlow = ((childElement.getBoundingClientRect().height + 20 + 25) > element.getBoundingClientRect().height)
                childElement.style.outline = isOverFlow ? '1px red solid' : 'none'
            }
        }
    }

    useEffect( () => {
        // const jsonData = data?.json ? JSON.parse(data.json) : data
        const jsonData = data?.json ? JSON.parse(data.json) : data
        if(jsonData?.colorPallet && type !== 'Text'){
            if(type === 'Pie'){
                pieFunc(jsonData)
            } else if(type === 'Donut'){
                donutFunc(jsonData)
            } else if(type === 'Box'){
                statFunc(jsonData)
            } else if(type === 'VBar'){
                verticalBarFunc(jsonData)
            } else if(type === 'HBar'){
                horizontalBarFunc(jsonData)
            }
            checkOverFlow()
        }
        if(type === 'Text'){
            freeTextFunc(jsonData)
        }
    }, [data])

    useEffect( () => {
        setTimeout(() => {
            checkOverFlow()
        }, 1000)
    }, [])

    return (
        <OuterWrapper
            data-title={data.textContent}
            className={`grid-item ${type}Wrapper`}
            style={styles}
        >
            {(!['NA', 'View', 'none'].includes(type)) && ROLES_MM_PRIMARY.includes(user?.UserType) && !isPPTModalActive &&
                <MuiButton className='editIcon' startIcon={<IconEdit2 />} size='small' color='gray' variant='text' onClick={() => onEditClicked(data)} />
            }

            {/* {['View', 'none'].includes(type) && */}
            {/* {!['Text', 'NA', 'Hidden'].includes(type) && defaultType === 'View' &&  */}
            {(type !== 'Text' && type !== 'NA' && type !== 'Hidden' && colorPallet?.length===0) &&
                <Wrapper index={data.id}>
                    {/* <MuiButton
                        size='small'
                        color='primary'
                        variant='outlined'
                        label='Add Content'
                        disabled={true}
                    /> */}
                </Wrapper>
            }
            {['NA'].includes(type) &&
                <Wrapper index={data.id}>
                    {defaultType !== 'View' && <MuiButton
                        size='small'
                        color='primary'
                        variant='outlined'
                        label='Add Content'
                        onClick={() => onClick(data)}
                    />}
                </Wrapper>
            }
            {type === 'noneeeeeeee' && 
                <Wrapper index={data.id}>
                    DATA MISSING
                </Wrapper>
            }
            {type === 'Pie' && colorPallet?.length>0 && pieSettings && pieData &&
                <D3PieWrapper>
                    <CardTitle className='wTitle'>{data.title}</CardTitle>
                    {pieData && <D3Pie data={[...pieData]} settings={{...pieSettings, colors:colorPallet}} />}
                    <D3PieLegends className='wContent' style={{width: (pieSettings.width)+'px', height: pieSettings.height + 'px'}}>
                        {pieLegends.map((d, i) => {
                            return (
                                <D3PieLegendLabel color={colorPallet[i]}>{d.name}</D3PieLegendLabel>
                            )
                        })}
                    </D3PieLegends>
                </D3PieWrapper>
            }
            {type === 'Donut' && colorPallet?.length>0 && pieSettings && pieData &&
                <D3DonutWrapper>
                    <CardTitle className='wTitle'>{data.title}</CardTitle>
                    <Box className='wContent'>
                        {pieData.map((d, i) => {
                            const val = String(d.value)
                            return (
                                <D3Donut color={colorPallet[i]}>
                                    <D3Pie data={donutCheckData(d)} settings={{...pieSettings, colors:[ colorPallet[i] ], textCenterTitle:''}} />
                                    {val?.length > 0 && <D3DonutValue color={colorPallet[i]}>{removeAllKeepNumber(val)}{(val.indexOf('%') !== -1) ? <D3DonutPercentage>%</D3DonutPercentage> : ''}</D3DonutValue>}
                                    <D3DonutLabel>{d.name}</D3DonutLabel>
                                </D3Donut>
                            )
                        })}
                    </Box>
                </D3DonutWrapper>
            }
            {type === 'Box' && colorPallet?.length>0 && statData?.data?.length > 0 &&
                <StatBoxWrapper color={colorPallet[0]}>
                    {statData?.title && <CardTitle className='wTitle'>{statData.title}</CardTitle>}
                    {statData?.data?.[0]?.label && <div class="percent-box">{statData?.data?.[0]?.value1 && <>{removeAllKeepNumber(statData.data[0].value1)} {hasPercentage(statData.data[0].value1) && <span>%</span>}</>}</div>}
                    {statData?.data?.[0]?.value2 && <div class="ratio-box">{statData.data[0].value2}</div>}
                    {statData?.data?.[0]?.label && <div class="footer-text">{statData.data[0].label}</div>}
                </StatBoxWrapper>
            }
            {type === 'VBar' && colorPallet?.length>0 && barData &&
                <D3VBarWrapper>
                    <CardTitle className='wTitle'>{data.title}</CardTitle>
                    <Box className='chart-container wContent'>
                        {barData?.length > 0 && barData.map((item, index) => (
                            <Box key={index} className="bar-group">
                                <Box className="bar">
                                    <D3VBar className="bar-fill" value={item.value} style={{ height: `${(item.value / maxBarValue) * 100}%`, backgroundColor: colorPallet[index]}}></D3VBar>
                                </Box>
                                <Box className="bar-label">{item.label}</Box>
                            </Box>
                        ))}
                    </Box>
                </D3VBarWrapper>
            }
            {type === 'HBar' && colorPallet?.length>0 && barData &&
                <D3HBarWrapper>
                    <CardTitle className='wTitle'>{data.title}</CardTitle>
                    <Box className='hBarWrap wContent'>
                        {barData?.length > 0 && barData.map((item, index) => {
                            return (
                                <D3HBar key={index} color={colorPallet[index]}>
                                    <Box className="item-name">{item.label}</Box>
                                    <Box className="bar-container">
                                        <Box className="bar-fill" style={{ width: `${( removeAllKeepNumber(item?.value || 0) / maxBarValue) * 100}%` }}></Box>
                                    </Box>
                                    <Box className="item-value">{ removeSpecialChar(item.value) }</Box>
                                </D3HBar>
                            )
                        })}
                    </Box>
                </D3HBarWrapper>
            }
            {type === 'Text' &&
                <FreeTextWrapper>
                    <CardTitle>{data.title}</CardTitle>
                    <Box className='freeTextWrap' dangerouslySetInnerHTML={{ __html: freeTextValue }} />
                </FreeTextWrapper>
            }
            {type === 'Hidden' &&
                <HiddenWrapper>
                    {ROLES_MM_PRIMARY.includes(user?.UserType) && !isPPTModalActive && defaultType==='View' && <CardTitle>{data.title}</CardTitle>}
                </HiddenWrapper>
            }

        </OuterWrapper>
    )
}

export default ViewWidget

